import { render, staticRenderFns } from "./GenerateAi.vue?vue&type=template&id=46426bac&scoped=true"
import script from "./GenerateAi.vue?vue&type=script&lang=js"
export * from "./GenerateAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46426bac",
  null
  
)

export default component.exports